import { Confirm } from "/WebInterface/new-ui/modules/alert.js";
import C from "/WebInterface/new-ui/assets/js/utils/log.js";
import { _$ } from "/WebInterface/new-ui/assets/js/utils/dom.js";
import store from "/WebInterface/new-ui/upload/js/reducer.js";
import { t } from "/WebInterface/new-ui/modules/localizations/localizations.js";
import {
  isFileOpen,
  blockUploads,
  unblockUploads,
} from "/WebInterface/new-ui/upload/utils/apis.js";

export const handleUpdateUploadingStatusCommon = (parent, uploading) => {
  const this_parent = parent;
  if (
    (uploading === true || uploading === false) &&
    uploading !== this_parent.fileUploadingInProgress
  ) {
    this_parent.fileUploadingInProgress = uploading;
    this_parent.invoke("setUploadingStatus", [
      "isUploading",
      this_parent.fileUploadingInProgress,
    ]);
  }

  return this_parent.fileUploadingInProgress;
};

export const handleRetryUploading = async (
  parent,
  retries,
  cb,
  callback = () => {},
  retryCallback = () => {}
) => {
  const this_parent = parent;

  const fileInfo = this_parent.streamingFileInfo;
  const { id: fileId, nameF } = fileInfo;

  if (this_parent.retrying) return;
  this_parent.retrying = true;

  retryCallback();

  // clearInterval(this_parent.chunksInfo.intervalId);

  let retrySeconds = (retries + 1) * 10;
  let retryIntervalId;

  const setRetryTimer = (close) => {
    const intervalId = setInterval(() => {
      retrySeconds--;
      _$("#retrySeconds").text(retrySeconds);

      if (retrySeconds === 0) {
        this_parent.retrying = false;
        clearInterval(retryIntervalId);
        cb();
        close();
      }
    }, 1000);

    return intervalId;
  };

  const onBeforeShow = (root, close) => {
    retryIntervalId = setRetryTimer(close);
  };

  const onAfterShow = (root, close) => {
    _$("#skipFile").on("click", async () => {
      clearInterval(retryIntervalId);
      try {
        const resp = await this_parent.invoke("confirmAlert", [
          {
            title: t("confirm"),
            body: t("areYouSureYouWantToCancelFileFromUploading", {
              fileName: nameF,
            }),
            confirm: t("yes"),
            cancel: t("no"),
            closable: true,
          },
        ]);
        if (resp) {
          close();
          this_parent.cancel();
          return;
        }

        retryIntervalId = setRetryTimer(close);
      } catch (error) {}
    });
  };

  const prepend = `<p class="text-primaryMain">Retrying uploading file <b>(${nameF})</b> In <span id="retrySeconds">${retrySeconds}</span> second(s)</p>`;

  try {
    const resp = await Confirm({
      title: "Retry",
      prepend,
      cancel: null,
      confirm: "Retry Now",
      closable: false,
      prependFooter: utils.generateHTML([
        {
          type: "button#skipFile.primary-button.is-bordered.mr-3",
          text: "Skip File",
        },
      ]),
      onBeforeShow,
      onAfterShow,
    });

    clearInterval(retryIntervalId);
    this_parent.retrying = false;

    if (resp) {
      if (retries < this_parent.maxRetries) {
        cb();
        return;
      }

      callback();
      handleFileOpenError(
        fileInfo,
        t("uploadingFailedWhileRetryingChunkUpload")
      );

      this_parent.nextFileInQueue(true);
      return;
    }
  } catch (error) {}
};

export const updateTimeStatusOfUploadingFileCommon = (
  resumeLoc = 0,
  parent
) => {
  const this_parent = parent;
  const { id: fileId, size } = this_parent.streamingFileInfo;

  // Initialize an array to store the last 10 speeds
  this_parent.chunksInfo.speeds = this_parent.chunksInfo.speeds || [];

  let lastUpdateTime = Date.now();
  const updateInterval = 1000; // Update every 1 second

  const updateStatus = () => {
    const now = Date.now();
    const timeSinceLastUpdate = now - lastUpdateTime;

    if (timeSinceLastUpdate < updateInterval) {
      requestAnimationFrame(updateStatus);
      return;
    }

    if (
      this_parent.isPaused ||
      this_parent.fileClosed ||
      this_parent.uploadDone
    ) {
      return;
    }

    lastUpdateTime = now;

    let elapsedTime = (now - this_parent.uploadStartTime || 0) / 1000;

    if (this_parent.pauseLog && this_parent.pauseLog.length > 0) {
      const pausedFor = this_parent.pauseLog.reduce((sum, item) => {
        return sum + (item.pausedFor ? item.pausedFor : 0);
      }, 0);
      if (pausedFor > 0) {
        elapsedTime = elapsedTime - pausedFor / 1000;
        this_parent.chunksInfo.elapsedTime = elapsedTime;
      }
    }

    // Upload speed calc - bytes per second
    const bytesUploadedSinceLastUpdate =
      this_parent.chunksInfo.bytesSent -
      this_parent.chunksInfo.lastBytesUploaded;
    const currentSpeed =
      bytesUploadedSinceLastUpdate / (timeSinceLastUpdate / 1000);

    // Add the current speed to the speeds array
    this_parent.chunksInfo.speeds.push(currentSpeed);

    // Keep only the last 10 speeds
    if (this_parent.chunksInfo.speeds.length > 10) {
      this_parent.chunksInfo.speeds.shift();
    }

    // Calculate the average speed over the last 10 updates
    const speed =
      this_parent.chunksInfo.speeds.reduce((sum, speed) => sum + speed, 0) /
      this_parent.chunksInfo.speeds.length;

    // Overall speed
    const overAllSpeed = this_parent.chunksInfo.bytesSent / elapsedTime;

    const speedToCheckTimeRemaining = overAllSpeed || speed;
    // time remaining calc - remaining size to upload divides by current upload speed
    let timeRemaining;
    if (speedToCheckTimeRemaining > 0) {
      const remainingBytes =
        size - resumeLoc - this_parent.chunksInfo.bytesSent;
      timeRemaining = remainingBytes / speedToCheckTimeRemaining;
      // Check if timeRemaining is NaN or Infinity
      if (!Number.isFinite(timeRemaining)) {
        timeRemaining = "-";
      }
    } else {
      timeRemaining = "-";
    }
    this_parent.chunksInfo.lastBytesUploaded = this_parent.chunksInfo.bytesSent;

    store.dispatch("updateFileTimeStatus", {
      fileId,
      speed,
      elapsedTime,
      timeRemaining,
      overAllSpeed,
    });

    if (
      this_parent.isPaused ||
      this_parent.fileClosed ||
      this_parent.uploadDone
    ) {
      return;
    }

    // Schedule the next update
    requestAnimationFrame(updateStatus);
  };

  // Start the first update
  requestAnimationFrame(updateStatus);
};

export const pausingUpload = (parent) => {
  const this_parent = parent;

  const fileInfo = this_parent.streamingFileInfo;
  const { id: fileId, size } = fileInfo;

  this_parent.isPaused = true;

  const updatedFileToPausing = {
    ...fileInfo,
    status: "pausing",
    chunkPos: this_parent.chunksInfo.chunkPos,
  };

  store.dispatch("updateFileStatusAndRerenderFile", {
    [fileId]: updatedFileToPausing,
  });

  // Update file upload status in the store
  store.dispatch("updateFileUploadStatus", {
    fileId,
    size: this_parent.chunksInfo.bytesUploaded,
    maxSize: size,
  });
};

export const pauseUpload = (parent) => {
  const this_parent = parent;

  this_parent.pauseLog.push({
    pausedAt: Date.now(),
  });

  const fileInfo = this_parent.streamingFileInfo;
  const { id: fileId, size } = fileInfo;

  this_parent.handleUpdateUploadingStatus(false);

  const updatedFile = {
    ...fileInfo,
    status: "paused",
    chunkPos: this_parent.chunksInfo.chunkPos,
  };

  // Update file status to "paused" and chunk position in the store
  store.dispatch("updateFileStatusAndRerenderFile", {
    [fileId]: updatedFile,
  });

  // Clear the interval responsible for chunk upload
  clearInterval(this_parent.chunksInfo.intervalId);

  // Update file upload status in the store
  store.dispatch("updateFileUploadStatus", {
    fileId,
    size: this_parent.chunksInfo.bytesUploaded,
    maxSize: size,
  });

  // Update file time status in the store
  store.dispatch("updateFileTimeStatus", {
    fileId,
    speed: 0,
    elapsedTime: this_parent.chunksInfo.elapsedTime,
  });
};

export const resumeUpload = async (parent, onResume = () => {}) => {
  const this_parent = parent;

  const isDownloadInProgress = this_parent.invoke("getDownloadStatus");

  if (isDownloadInProgress) {
    this_parent.invoke("growl", [
      t("cantResumeUploadingTillDownloadingFinished"),
      t("downloadingInProgress"),
      5000,
      true,
    ]);
    return;
  }

  const fileInfo = this_parent.streamingFileInfo;
  const { id: fileId, size, reUploadId } = fileInfo;
  this_parent.isPaused = false;

  try {
    const resp = await isFileOpen({
      upload_id: reUploadId || fileId,
      random: Math.random(),
      chunkInfo: JSON.stringify({}),
    });

    if (resp.toLowerCase() === "open") {
      const updatedFile = {
        ...fileInfo,
        status: "uploading",
        chunkPos: this_parent.chunksInfo.chunkPos,
      };

      // Update file status and chunk position in the store
      store.dispatch("updateFileStatusAndRerenderFile", {
        [fileId]: updatedFile,
      });

      // Update file upload status in the store
      store.dispatch("updateFileUploadStatus", {
        fileId,
        size: this_parent.chunksInfo.bytesUploaded,
        maxSize: size,
      });

      onResume();

      if (this_parent.pauseLog.length > 0) {
        const logToUpdate =
          this_parent.pauseLog[this_parent.pauseLog.length - 1];
        if (!logToUpdate.resumedAt) {
          logToUpdate.resumedAt = Date.now();
          logToUpdate.pausedFor = Date.now() - logToUpdate.pausedAt;
        }
      }

      // Update the time status of the uploading file
      this_parent.updateTimeStatusOfUploadingFile(
        this_parent.chunksInfo.chunkPos
      );
    } else {
      this_parent.invoke("growl", ["", t("cantResumeFile"), 4000, true]);
      C.error("Upload:Error occurred during resume operation:", error);
    }
  } catch (error) {
    // Handle any errors if necessary
    this_parent.invoke("growl", ["", t("cantResumeFile"), 4000, true]);
    C.error("Upload:Error occurred during resume operation:", error);
  }
};

export const closeFileUsingBlockUnBlockUpload = async (
  preStatus = {
    status: "canceling",
  },
  postStatus = {
    status: "canceled",
  },
  beforeClosingFile = () => {},
  parent
) => {
  const this_parent = parent;

  const fileInfo = this_parent.streamingFileInfo;
  const { id: fileId, size, reUploadId } = fileInfo;

  this_parent.fileClosed = true;

  beforeClosingFile();

  if (preStatus) {
    store.dispatch("updateFileStatusAndRerenderFile", {
      [fileId]: {
        ...fileInfo,
        ...preStatus,
      },
    });
  }

  store.dispatch("updateFileTimeStatus", {
    fileId,
    speed: 0,
    elapsedTime: this_parent.chunksInfo.elapsedTime,
  });

  store.dispatch("updateFileUploadStatus", {
    fileId,
    size: this_parent.chunksInfo.bytesUploaded,
    maxSize: size,
  });

  const blockFile = async () => {
    try {
      // Block uploads with random token
      console.log("Blocking uploads");
      await blockUploads({
        fileId: reUploadId || fileId,
        random: Math.random(),
      });
      const fileStatus = await isFileOpen({
        upload_id: reUploadId || fileId,
        random: Math.random(),
        chunkInfo: JSON.stringify({}),
      });
      console.log("File status:", fileStatus);
      const fileOpen = fileStatus.toLowerCase().indexOf("open") >= 0;
      if (fileOpen) {
        setTimeout(() => {
          blockFile();
        }, 1000);
        return;
      }

      // Update file status to "canceled" in the store
      if (postStatus) {
        store.dispatch("updateFileStatusAndRerenderFile", {
          [fileId]: {
            ...fileInfo,
            ...postStatus,
          },
        });
      }

      // Unblock uploads with another random token
      console.log("Unblocking uploads");
      await unblockUploads({ random: Math.random() });

      // Reset isPaused flag and proceed to the next file in the queue
      this_parent.nextFileInQueue(true);
    } catch (error) {
      // Handle any errors if necessary
      if (postStatus) {
        store.dispatch("updateFileStatusAndRerenderFile", {
          [fileId]: {
            ...fileInfo,
            ...postStatus,
            uploadingError: error?.message,
          },
        });
      }
      console.log("Upload:Error occurred during cancel operation:", error);
    }
  };

  blockFile();
};

export const handleFileOpenResponse = (parent, file, response, resumeLoc) => {
  if (response.toLowerCase().indexOf("error") >= 0) {
    parent.failFileOpen(file, response);
  } else {
    parent.startFileUpload(file, resumeLoc);
  }
};

export const failFileOpenCommon = (parent, file, response) => {
  handleFileOpenError(file, response);
  parent.invoke("growl", ["", response, 5000, true]);
  parent.nextFileInQueue(true);
};

export const startFileUploadCommon = (parent, file, resumeLoc) => {
  if (file.size === 0) {
    C.log(`Upload: File is empty: ${file.nameF}, does not require upload`);
    parent.closeFileStream(file);
    return;
  }
  store.dispatch("updateFileStatusAndRerenderFile", {
    [file.id]: {
      ...file,
      status: "uploading",
    },
  });
  window.addEventListener("beforeunload", parent.beforeUnloadEvent);
  store.dispatch("showFileUploadStatus", {
    fileId: file.id,
    size: file.size,
    resumeLoc,
  });
  C.success(`Upload: File upload started: ${file.nameF}`);
  parent.updateTimeStatusOfUploadingFile(resumeLoc);
  parent.uploadTheNextSetOfChunk(resumeLoc);
};

export const handleCloseFileRetryCommon = async (parent, error) => {
  const fileInfo = parent.streamingFileInfo;
  const { nameF } = fileInfo;

  if (parent.closeFileRetries >= parent.maxCloseFileRetries) {
    return;
  }

  parent.closeFileRetries++;
  let retrySeconds = parent.closeFileRetries * 10;
  let retryIntervalId;

  const setRetryTimer = (close) => {
    const intervalId = setInterval(() => {
      retrySeconds--;
      _$("#retrySeconds").text(retrySeconds);

      if (retrySeconds === 0) {
        parent.retrying = false;
        clearInterval(retryIntervalId);
        parent.fileClosed = false;
        parent.closeFileStream(fileInfo);
        close();
      }
    }, 1000);

    return intervalId;
  };

  const onBeforeShow = (root, close) => {
    retryIntervalId = setRetryTimer(close);
  };

  const onAfterShow = (root, close) => {
    _$("#skipFile").on("click", async () => {
      clearInterval(retryIntervalId);
      try {
        const resp = await parent.invoke("confirmAlert", [
          {
            title: t("confirm"),
            body: t("areYouSureYouWantToCancelFileFromClosing", {
              fileName: nameF,
            }),
            confirm: t("yes"),
            cancel: t("no"),
            closable: true,
          },
        ]);
        if (resp) {
          close();
          clearInterval(parent.chunksInfo.intervalId);
          C.log(`Upload: Clearing interval: ${parent.chunksInfo.intervalId}`);
          handleFileOpenError(fileInfo, error);
          parent.invoke("growl", [error, t("fileClosingFailed"), 4000, true]);
          parent.nextFileInQueue(true);
          return;
        }

        retryIntervalId = setRetryTimer(close);
      } catch (error) {}
    });
  };

  const prepend = `<p class="text-primaryMain">Retrying closing file <b>(${nameF})</b> In <span id="retrySeconds">${retrySeconds}</span> second(s)</p>`;

  try {
    const resp = await Confirm({
      title: "Retry",
      prepend,
      cancel: null,
      confirm: "Retry Now",
      closable: false,
      prependFooter: utils.generateHTML([
        {
          type: "button#skipFile.primary-button.is-bordered.mr-3",
          text: "Skip File",
        },
      ]),
      onBeforeShow,
      onAfterShow,
    });

    clearInterval(retryIntervalId);
    parent.retrying = false;

    if (resp) {
      if (parent.closeFileRetries < parent.maxCloseFileRetries) {
        parent.fileClosed = false;
        parent.closeFileStream(fileInfo);
        return;
      }

      clearInterval(parent.chunksInfo.intervalId);
      C.log(`Upload: Clearing interval: ${parent.chunksInfo.intervalId}`);
      handleFileOpenError(fileInfo, error);
      parent.invoke("growl", [error, t("fileClosingFailed"), 4000, true]);
      parent.nextFileInQueue(true);
      return;
    }
  } catch (error) {}
};

export const handleFileOpenError = (file, error) => {
  C.error(error);
  store.dispatch("updateFileStatusAndRerenderFile", {
    [file.id]: {
      ...file,
      status: "failed",
      uploadingError: error,
    },
  });
};

export const isMakeDirResponseValid = (resp) => {
  if (!resp) return false;
  const message = decodeURIComponent(resp).toLowerCase();
  if (message.includes("error")) return false;
  if (message.includes("failed")) return false;
  if (message.includes("not allowed")) return false;
  return true;
};
